module.exports = __webpack_public_path__ + "static/img/2.19030e3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/showcase/xi/my/8/2.png
// module id = +uBx
// module chunks = 1